import { Spin } from 'antd';
import React, { Suspense } from 'react';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin flex items-center justify-center h-[calc(100vh-132px)]">
            <Spin />
          </div>
        }
      >
        <div
          style={{
            backgroundColor: '#93deff',
            minHeight: '100vh',
          }}
          className="bg-top bg-no-repeat"
        >
          <WraperContent />
        </div>
      </Suspense>
    );
  };
};

export default AuthLayout;
